/** Legacy keys — platform tokens must live server-side only (Meta / security). */
const LEGACY_PLATFORM_TOKEN_KEYS = [
  'facebook_access_token',
  'linkedin_access_token',
  'youtube_access_token',
  'tumblr_access_token',
  'instagram_access_token',
];

export function clearLegacyPlatformTokensFromStorage() {
  try {
    LEGACY_PLATFORM_TOKEN_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* ignore quota / private mode */
  }
}
